<template>
    <div class="view-body view-body--module">
      <div class="view-data view-data--module">
        <div class="file-wrapper">
            <div class="alert alert-danger validation-alert" v-if="invalidFormat">
              Prześlij plik jpg, png lub pdf.
            </div>
            <form @submit.prevent="onSubmit" class="file">
                <input type="file" name="fileInput" ref="fileInput"  @change="handleFilesUploads()" multiple>
                <p>{{text}}</p>
            </form>
            <ul class="files-list">
              <li v-for="file in files">
                <span @click="downloadSingle(file.path, file.name)"><img src="../../assets/symbols/clip.svg" /></span>
                <p>{{file.name}} </p>
              </li>
            </ul>
            <div v-if="files.length" class="button-group add-group" @click="downloadZip()">
              <span class="button-normal button-normal--add button-normal--small">
                <img src="@/assets/symbols/download.svg" />
              </span>
              <label class="add-label">Pobierz załączniki</label>
            </div>
        </div>
      </div>
  </div>

</template>

<script>
export default {

    name: 'editOrderUpload',
    data(){
        return{

            text: 'Prześlij załączniki',
            fileInput: [],
            files: [],

            invalidFormat: false,
            fileMessage: '',

        }
    },
    props:{

        orderId:{
        type: Number,
        default: 0
        },

        specId:{
        type: Number,
        default: 0
        },

        type:{
        type: String,
        default: 'order'
        },

        pageId:{
        type: Number,
        default: 0,
        },

        loadedFiles:{
          type: Array,
          default: [],
        }

    },
    methods:{

        handleFilesUploads(){

            this.fileInput = this.$refs.fileInput.files;
            console.log(this.$refs.fileInput.files.length);
            if ( this.$refs.fileInput.files.length ) {
              this.prepareFiles();
              this.invalidFormat = false;
            }
        },

        prepareFiles(){

            let formData = new FormData();

            for( var i = 0; i < this.fileInput.length; i++ ){

                let file = this.fileInput[i];

                formData.append('files[' + i + ']', file);
                
            }

            if ( this.fileInput ) {
              this.addFiles(formData);
            }

        },

        addFiles(formData){
            
            let endpoint;

            if(this.type == 'page'){

                endpoint = `order-pages/${this.pageId}/adds/attachments`;

            }else if(this.type == 'order'){

                endpoint = `orders/${this.orderId}/adds/attachments`;

            }

            const token = localStorage.getItem('auth_token');

            this.$http.post(endpoint, formData, {
                headers: {

                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'

                }})
            .then(response => {

                this.$parent.getOrder();

            })
            .catch(error => {

                if(error.response.status === 400) {

                  this.invalidFormat = true;
                  return;

                }

                console.error(error);

            })

        },
        
        downloadSingle(url, name){

          let link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', name);
          link.setAttribute('target', '_blank');
          document.body.appendChild(link);
          link.click();

        },

        downloadZip(){

          const token = localStorage.getItem('auth_token');

          this.$http.get(`orders/${this.orderId}/attachments/zip`, {
            headers: {

            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'

            }
            })
            .then(response => {
              
              if (response.data){

                let name = response.data.url.split('/').pop();


                const link = document.createElement('a');
                link.href = response.data.url;
                link.setAttribute('download', name);
                document.body.appendChild(link);
                link.click();

              }

            })
            .catch(error =>{

                console.error(error.response);

            })

        },

    },
    watch:{

      loadedFiles: function(){

        this.files = this.loadedFiles;

      },

    },
    mounted(){

      this.files = this.loadedFiles;

    },

}
</script>

<style lang="scss" scoped>

.view-body--module{
  width:100%;
  left:0;
}

.file-wrapper{
    width:100%;
    margin:20px 0px;
}

.file{
    display:flex;
    position:relative;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border: 2px dashed rgb(214, 214, 214);
    height:100px;
    transition-duration: 0.2s;
    background:none;

    &:hover{
        opacity:0.5;
        transition-duration: 0.2s;
        background:rgb(235, 235, 235);
    }
}

.file p{
  width: 100%;
  text-align: center;
}

.file input{
  position: absolute;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  outline: none;
  opacity: 0;
}

.files-list{
 margin:10px 0px;
 padding: 0;

  & li{
    display:flex;
    justify-content: space-between;
    align-items: center;
    list-style: none;
    padding: 5px 0px;

    & span{
      width:5%;

      & img{
        width:100%;
      }
    }

    & p{
      display:flex;
      width:92%;
      margin:0;
      word-break: break-all;
      cursor:default;

      & span{
        margin-left: 10px;
        width:20px;
        visibility: hidden;
      }

      &:hover span{
        visibility: visible;
      }
    }

  }

}

</style>
